import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import images from '../images';

const MobileHeaderBottom = () => {
  const location = useLocation();

  const getActivePage = (pathname) => {
    if (pathname.includes('/my-leads')) return '/my-leads';
    if (pathname.includes('/profile')) return '/profile';
    return '/my-flows';
  };

  const activePage = getActivePage(location.pathname);

  const navItems = [
    { path: '/my-flows', icon: images.dashboard, iconActive: images.dashboardActive, label: 'Потоки' },
    { path: '/my-leads', icon: images.people, iconActive: images.peopleActive, label: 'Идентификации' },
    { path: '/profile', icon: images.user, iconActive: images.userActive, label: 'Профиль' },
  ];

  return (
    <div className="mobile-header-bottom">
      <div className="mobile-nav-container">
        {navItems.map((item) => {
          const isActive = activePage === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            >
              <img
                src={isActive ? item.iconActive : item.icon}
                alt={item.label}
                className="mobile-nav-icon"
              />
              <span className={`mobile-nav-text ${isActive ? 'visible' : 'hidden'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileHeaderBottom;
